import React, { Component, Fragment } from 'react';
import { Resizable } from "re-resizable";
import { Button } from 'reactstrap';

export default class ResizableWithControls extends Component {
  constructor() {
    super();
    this.state = {
      height: null,
      isResizing: false,
      dragStartY: null
    };
  }
  // FIX 20260731-barfit 一覧の下端が画面内に収まる上限を計算
  // 動画・YouTube: タイムラインバー基準 / それ以外: 拡大縮小バー基準。その10px上で止める
  calcMaxHeight = () => {
    try {
      const dragBarEl = document.querySelector('.marker-items-nav');
      const paneEl = document.querySelector('.animation-markers-pane');
      const anchorEl = document.querySelector('.tm-mini-bars') || document.getElementById('slider-scale-box');
      if (!dragBarEl || !paneEl || !anchorEl) return Infinity;
      // FIX 20260731-barfit 画面下端を基準にし、アンカー(動画・YouTube=タイムライン / それ以外=拡大縮小)の下端が
      // 画面内の10px上に収まるよう、はみ出した分だけ一覧を縮める
      const over = anchorEl.getBoundingClientRect().bottom - (window.innerHeight - 10);
      if (over <= 0) return Infinity;
      const cur = document.querySelector('.image-list-comment');
      const curH = cur ? cur.getBoundingClientRect().height : 0;
      const v = curH - over;
      return v > 100 ? v : 100;
    } catch (e) { return Infinity; }
  };

  // FIX 20260731-barfit 初回表示時にも適用し、はみ出す場合だけ縮める
  componentDidMount() {
    this._fitDone = false;
    this._fitTimers = [400, 1200, 2500].map((ms) => setTimeout(this.fitToScreen, ms));
    // 初回分が終わったら自動調整を打ち切る
    this._fitTimers.push(setTimeout(this.markFitDone, 3000));
  }

  componentWillUnmount() {
    if (this._fitTimers) this._fitTimers.forEach(clearTimeout);
    document.removeEventListener('mousemove', this.handleDragMove);
    document.removeEventListener('mouseup', this.handleDragEnd);
  }

  fitToScreen = () => {
    // FIX 20260731-barfit 初回表示の1回だけ収める。以降は手動優先で一切触らない
    if (this._fitDone || this.state.isResizing) return;
    const { defaultHeight } = this.props;
    const cur = this.state.height || defaultHeight;
    const max = this.calcMaxHeight();
    if (max !== Infinity && cur > max) this.setState({ height: max });
  };

  // FIX 20260731-barfit 一度でも手で動かしたら、以降は自動調整をしない
  markFitDone = () => { this._fitDone = true; };

  handleDragStart = (e) => {
    this.markFitDone();
    e.preventDefault();
    const clientY = e.type === 'mousedown' ? e.clientY : e.touches[0].clientY;
    
    this.setState({ 
      isResizing: true,
      dragStartY: clientY 
    });

    if (e.type === 'mousedown') {
      document.addEventListener('mousemove', this.handleDragMove);
      document.addEventListener('mouseup', this.handleDragEnd);
    }
  };

  handleDragMove = (e) => {
    if (this.state.isResizing && this.state.dragStartY !== null) {
      const clientY = e.type === 'mousemove' ? e.clientY : e.touches[0].clientY;
      const deltaY = clientY - this.state.dragStartY;
      const { defaultHeight } = this.props;

      // FIX 20260731-barfit 手で動かす時は制限しない(画面外へでも伸ばせる従来の仕様を維持)
      const maxHeight = Infinity;

      this.setState(prevState => ({
        height: Math.min(Math.max((prevState.height || defaultHeight) + deltaY, 100), maxHeight),
        dragStartY: clientY
      }));
    }
  };
  handleDragEnd = () => {
    this.setState({ 
      isResizing: false,
      dragStartY: null 
    });
    
    document.removeEventListener('mousemove', this.handleDragMove);
    document.removeEventListener('mouseup', this.handleDragEnd);
  };

  render() {
    const { height, isResizing } = this.state;
    const { defaultHeight, className, children, enable, wrapperClass, isMobile } = this.props;
    return (
      <Fragment>
        <div className={wrapperClass}>
          <Resizable
            className={className}
            defaultSize={{ height: defaultHeight }}
            size={{ height: height || defaultHeight }}
            enable={ enable }
            sizeStyle={{height: 'min-height: 50px'}}
            onResizeStart={(e) => {
              e.preventDefault();
              this.setState({ isResizing: true });
            }}
            onResizeStop={(e, direction, ref, d) => {
              this.setState({
                height: (height || defaultHeight) + d.height,
                isResizing: false
              });
            }}
          >
            {children}
          </Resizable>
        </div>
        { (
            <div className="marker-items-nav width-100percent border-t">
              <div className="d-flex justify-content-center align-items-center h-0"
                  onMouseDown={this.handleDragStart}
                  onTouchStart={this.handleDragStart}
                  onTouchMove={this.handleDragMove}
                  onTouchEnd={this.handleDragEnd}
                  onTouchCancel={this.handleDragEnd}
                  style={{
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    MozUserSelect: 'none',
                    msUserSelect: 'none',
                    touchAction: 'none'
                  }}
              >
                <i className="resize-bar mr-2 cursor-ns-resize text-white"></i>
                  <span className='text-white cursor-ns-resize'> 高さ調整バー </span>
                <i className="resize-bar ml-2 cursor-ns-resize text-white"></i>
              </div>
            </div>
          )
        }
      </Fragment>
    );
  }
}
